export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover a ocorrência <b>${this.currentEntity.id}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/book-occurrence/index/resources/computed.js